import { useSegment } from '../useSegment'
import type { BaseEvent } from './base'

interface EventData {
  experimentName: string
  experimentVariant: string
}

const KNOWN_USER_EXPERIMENT = 'known-' as const

const formatExperimentName = (experimentName: string): string => {
  return experimentName.replace(/^(experiment-)/, '')
}

const experimentStartedFlags = new Set<string>()

export const useExperimentStartedEvent: BaseEvent<EventData> = (analytics = useSegment) => {
  const send = ({ experimentName, experimentVariant }: EventData): void => {
    const isKnownUserExperiment = experimentName.startsWith(KNOWN_USER_EXPERIMENT)

    // Don't track known user experiments. These are seeded when we capture the user's email address.
    if (isKnownUserExperiment) {
      return
    }

    // Prevent duplicate events for the same experiment
    if (experimentStartedFlags.has(experimentName)) {
      return
    }

    // Add the experiment to the set of started experiments
    experimentStartedFlags.add(experimentName)

    // Don't track experiments that don't have a variant.
    if (!experimentVariant) {
      return
    }

    const formattedExperimentName = formatExperimentName(experimentName)

    analytics().track('Experiment Started', {
      experiment_name: formattedExperimentName,
      experiment_variant: experimentVariant,
    })
  }

  return {
    send,
  }
}
